module.exports = __webpack_public_path__ + "img/logo-icon-white.0ceb8ed7.svg";